import {Dialog, Transition} from '@headlessui/react';
import {Context} from '../../../../Helpers/Auth';
import SelectComponent from '../../../Selects/SelectComponent';
import React, {useState, Fragment, useRef, useContext, useEffect} from 'react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {useTranslation} from 'react-i18next';

import i18n from '../../../../i18n';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {getVIES} from '../../../../pages/requests';

// import { Container } from './styles';

function Detalhes({info}) {
    const {t} = useTranslation();
    const history = useHistory();
    const {
        onBlurNif,
        setOnBlurNif,
        paises,
        prospect,
        setPais,
        setValidacaoRS,
        pais,
        setLingua,
        linguas,
        lingua,
        setDivisa,
        moedas,
        divisa,
        setNif,
        validacaoNif,
        nif,
        tamanhoNif,
        setValidacaoNif,
        setRazaoSocial,
        razaoSocial,
        msgNif,
        setCategoria,
        categorias,
        categoria,
        setResponsavel,
        responsaveis,
        responsavel,
        setOrigem,
        origens,
        origem,
        editarProspect,
        validacaoRS,
        validacaoPais,
        validacaoLingua,
        validacaoDivisa,
        validacaoCategoria,
        validacaoRep,
        validacaoOrigem,
        setValidacaoPais,
        setValidacaoLingua,
        setValidacaoDivisa,
        setValidacaoCategoria,
        setValidacaoRep,
        setValidacaoOrigem,
        setOnChangeForm,

        linhasEnderecos,
        setLinhasEnderecos,

        actividades,
        setActividade,
        actividade,
        setValidacaoActividade,
        validacaoActividade,

        familia1,
        familia2,
        familia3,
        familia4,
        familia5,
    } = info;

    const {rep, acessos, utilizador} = useContext(Context);

    function getVies(nif) {
        let countryCode = nif.slice(0, 2);
        let vatNumber = nif.slice(2);

        getVIES(countryCode.toUpperCase(), vatNumber)
            .then(res => {
                const pais = countryCode.toUpperCase();
                if (res.data.success && res.data.vies.valida) {
                    const foundCountry = paises.find(e => e.value === pais);

                    if (foundCountry) {
                        setPais(foundCountry);
                    }
                    setRazaoSocial(res.data.vies.nome);

                    if (linhasEnderecos.length === 1) {
                        var a = res.data.vies.morada.split(/(\d{4}-\d{3})/);

                        setLinhasEnderecos([
                            {
                                id: 'E001',
                                pais: foundCountry,
                                morada: a[0],
                                codigoPostal: a[1],
                                cidade: a[2],
                                enderecoDefeito: true,
                                descricao: '',
                                latitude: '',
                                longitude: '',
                            },
                            // linha Vazia
                            {
                                id: '',
                                pais: null,
                                morada: '',
                                codigoPostal: '',
                                cidade: '',
                                enderecoDefeito: false,
                                descricao: '',
                                latitude: '',
                                longitude: '',
                            },
                        ]);
                    }
                    // setConfirmacaoNifMorada(res.data.vies.morada)
                }
            })
            .catch(error => {
                toast.warn(error, {
                    position: 'top-right',
                    autoClose: 6000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
            });
    }

    return (
        <>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="nif" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('nif')}*
                    </label>
                    <input
                        type="text"
                        className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            validacaoNif ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                        }${editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'}`}
                        placeholder="ex: PT123456789"
                        required
                        value={nif}
                        maxLength={tamanhoNif}
                        onChange={e => {
                            setNif(e.target.value.toUpperCase());
                            setValidacaoNif(false);
                            setOnChangeForm(true);
                            if (e.target.value.toUpperCase().length == 11) {
                                getVies(e.target.value.toUpperCase());
                            }
                        }}
                        disabled={!editarProspect}
                    />
                    {validacaoNif ? <small className="text-red-500">{msgNif}</small> : null}
                </div>
                <div>
                    <label htmlFor="razaoSocial" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('razaoSocial')}*
                    </label>
                    <input
                        value={razaoSocial}
                        maxLength={60}
                        type="text"
                        className={`border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                            validacaoRS ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                        }${editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'}`}
                        required
                        onChange={e => {
                            setRazaoSocial(e.target.value);
                            setValidacaoRS(false);
                            setOnChangeForm(true);
                        }}
                        disabled={!editarProspect}
                    />
                    {validacaoRS ? <small className="text-red-500">{t('insiraRazaoSocial')}</small> : null}
                </div>
            </div>
            <div className="mb-3">
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{t('pais')}*</label>
                <SelectComponent
                    isDisabled={!editarProspect}
                    options={paises}
                    value={pais}
                    onChange={e => {
                        setPais(e);
                        setValidacaoPais(false);
                        setOnChangeForm(true);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('selecioneOpcao')}
                />
                {validacaoPais && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('lingua')}*
                    </label>
                    <SelectComponent
                        isDisabled={!editarProspect}
                        options={linguas}
                        value={lingua}
                        onChange={e => {
                            setLingua(e);
                            setValidacaoLingua(false);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {validacaoLingua && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                </div>
                <div>
                    <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('divisa')}*
                    </label>
                    <SelectComponent
                        isDisabled={!editarProspect}
                        options={moedas}
                        value={divisa}
                        onChange={e => {
                            setDivisa(e);
                            setValidacaoDivisa(false);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {validacaoDivisa && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                </div>

                <div>
                    <label htmlFor="categoria" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('categoria')}*
                    </label>
                    <SelectComponent
                        isDisabled={!editarProspect}
                        options={categorias}
                        value={categoria}
                        onChange={e => {
                            setCategoria(e);
                            setValidacaoCategoria(false);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {validacaoCategoria && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                </div>
                <div>
                    <label htmlFor="responsaveis" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('representante')}*
                    </label>
                    <SelectComponent
                        isDisabled={!editarProspect}
                        options={responsaveis}
                        value={responsavel}
                        onChange={e => {
                            setResponsavel(e);
                            setValidacaoRep(false);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {validacaoRep && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                </div>
            </div>

            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="origens" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('origem')}*
                    </label>
                    <SelectComponent
                        isDisabled={!editarProspect}
                        options={origens}
                        value={origem}
                        onChange={e => {
                            setOrigem(e);
                            setValidacaoOrigem(false);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {validacaoOrigem && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                </div>
                <div>
                    <label htmlFor="actividade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('actividade')}*
                    </label>
                    <SelectComponent
                        isDisabled={!editarProspect}
                        options={actividades}
                        value={actividade}
                        onChange={e => {
                            setActividade(e);
                            setValidacaoActividade(false);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                    {validacaoActividade && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                {familia1 && (
                    <div>
                        <label htmlFor="actividade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('familia1')}
                        </label>
                        <SelectComponent
                            isDisabled={true}
                            //options={}
                            value={familia1}
                            onChange={e => {
                                //setOnChangeForm(true);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                )}
                {familia2 && (
                    <div>
                        <label htmlFor="actividade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('familia2')}
                        </label>
                        <SelectComponent
                            isDisabled={true}
                            //options={}
                            value={familia2}
                            onChange={e => {
                                //setOnChangeForm(true);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                )}
                {familia3 && (
                    <div>
                        <label htmlFor="actividade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('familia3')}
                        </label>
                        <SelectComponent
                            isDisabled={true}
                            //options={}
                            value={familia3}
                            onChange={e => {
                                //setOnChangeForm(true);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                )}
                {familia4 && (
                    <div>
                        <label htmlFor="actividade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('familia4')}
                        </label>
                        <SelectComponent
                            isDisabled={true}
                            //options={}
                            value={familia4}
                            onChange={e => {
                                //setOnChangeForm(true);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                )}
                {familia5 && (
                    <div>
                        <label htmlFor="actividade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('familia5')}
                        </label>
                        <SelectComponent
                            isDisabled={true}
                            //options={}
                            value={familia5}
                            onChange={e => {
                                //setOnChangeForm(true);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>
                )}
            </div>
        </>
    );
}

export default Detalhes;
